import React from 'react';
import FooterComponent from './FooterComponent';
import EditOrderContentComponent from './EditOrderContentComponent';

class EditOrderComponent extends React.Component {
    render() {
        return (
            <div className="main-panel">
                <EditOrderContentComponent id={this.props.id}/>
                <FooterComponent />
            </div>
        );
    }
}

export default EditOrderComponent;